import firebase from 'firebase';
import socket from '../globals/socket';
import {
  user_signed_in,
  user_signed_out,
  login_error_handler
} from './types';
import env from '../globals/environment';

export const getAuthStatus = () => {
  return (dispatch, getState) => {
    firebase.auth().onAuthStateChanged(async user => {
      if (user) {
        try {
          socket.connect();
          const idToken = await user.getIdToken();

          let workspace = window.location.host.split('.')[0];

          if (workspace.indexOf('localhost') !== -1) workspace = 'interapt';

          const response = await fetch(`${env.backendUrl}/auth/${workspace}?token=${idToken}`);

          if (response.ok) {
            const token = await response.json();
            dispatch({ type: user_signed_in, payload: token.token });

            socket.on('deactivated', id => {
              if (id === getState().usersStore.currentUser._id) dispatch({ type: user_signed_out });
            });
          } else {
            const error = await response.json();
            const message = error.message;
            const workspace = response.url.split(/[\s?/]+/)[3];
            const data = { message, workspace };
            dispatch({ type: login_error_handler, payload: data });
            throw error.message;
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        dispatch({ type: user_signed_out });
      }
    });
  };
};

export const signIn = () => {
  return () => {
    const provider = new firebase.auth.GoogleAuthProvider();

    provider.setCustomParameters({ prompt: 'select_account' });

    firebase.auth().signInWithPopup(provider);
  };
};

export const signOut = () => {
  socket.socket.disconnect();
  return () => firebase.auth().signOut();
};

export const fetchWithTokenRefresh = (url, options) => {
  return async dispatch => {
    try {
      if (options.method === 'PUT' || options.method === 'POST') options.headers = { ...options.headers, "Content-Type": "application/json" };
      options.headers = { ...options.headers };

      let response = await fetch(url, options);

      if (response.ok) return response;

      response = await response.json();

      if (response.message.indexOf('Firebase ID token has expired') === -1) return response;

      const newToken = await firebase.auth().currentUser.getIdToken(true);

      dispatch({
        type: user_signed_in,
        payload: newToken
      });

      options.headers.idtoken = newToken;

      return fetch(url, options);
    } catch (error) {
      console.log(error);
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/AuthActions.js